import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step8 } from '../../../../shared/models/component-messages/mapaIN/step8';
import { QualificationsProfessionnelles } from '../models/QualificationsProfessionnelles';
@Component({
  selector: 'app-qualifications-professionnelles',
  templateUrl: './qualifications-professionnelles.component.html'
})
export class QualificationsProfessionnellesComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'QualificationsProfessionnelles';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() qualificationsProfessionnelles: QualificationsProfessionnelles;

  public step8 = new Step8();

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

